import { Component, OnInit } from '@angular/core';
import { AssetStatisticsRequest } from '../../../../models/ss-api/requests/asset.statistics.request';
import { AssetStatisticsItemArray } from '../../../../models/ss-api/responses/asset.statistics.item';
import { ssApiService } from '../../../../services/ss-api.service';
import { SweetAlertService } from 'ng2-cli-sweetalert2';
import * as moment from 'moment';

@Component({
    selector: 'material-stats',
    templateUrl: './material.stats.component.html',
    styleUrls: ['./material.stats.component.css']
})
export class MaterialStatsComponent implements OnInit {
    IsBusy: boolean = false;

    statisticsResultRows: number = 25;
    firstResult: number = 0;
    lastResult: number = 24;

    // VARIABLES
    Keyword: string;
    StartDate: Date;
    EndDate: Date;

    StatisticsFilter: string;

    Statistics: AssetStatisticsItemArray = new AssetStatisticsItemArray();

    constructor(private api: ssApiService, private sweetAlert: SweetAlertService) { }

    ngOnInit() {
        this.StartDate = moment().subtract(30, 'days').toDate();
        this.EndDate = new Date();
    }

    ConcatLabel(label: string) {
        let regex = new RegExp(/([^\\]+$)/gm);
        let name = label.match(regex).splice(0, 1);

        return name;
    }

    LoadStats() {
        this.IsBusy = true;
        let request = new AssetStatisticsRequest();
        request.StartDate = this.StartDate;
        request.EndDate = this.EndDate;
        request.ItemCategoryTypes = [30];
        request.Keyword = this.Keyword;
        request.MaxItemCount = 5000;

        if (request.StartDate == null || request.StartDate == undefined) {
            this.sweetAlert.swal({
                type: 'error',
                title: 'No Start Date',
                text: 'Please select a start date to begin searching'
            }).then(() => { }, () => { });
            this.IsBusy = false;
            return false;
        }

        if (request.EndDate == null || request.EndDate == undefined) {
            this.sweetAlert.swal({
                type: 'error',
                title: 'No End Date',
                text: 'Please select a end date to begin searching'
            }).then(() => { }, () => { });
            this.IsBusy = false;
            return false;
        }

        let subscription = this.api.AssetStatistics(request).subscribe(result => {

            subscription.unsubscribe();

            this.Statistics = result.Data;
            this.IsBusy = false;
        });
    }

    CanSearch() {
        if (!this.StartDate || !this.EndDate)
            return false;

        return true;
    }

    paginateStatistics(e) {
        this.firstResult = e.page * e.rows;
        this.lastResult = this.firstResult + e.rows;
    }

}
